import withDismount from 'hocs/withDismount';

const FounderInvestorDetail = () => <div>Hey</div>;

export default withDismount(FounderInvestorDetail);
